"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DeleteWRedirect = exports.Delete = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var styles_1 = require("@material-ui/core/styles");
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var notistack_1 = require("notistack");
var Hoc = __importStar(require("../hoc"));
var utils_1 = require("../utils");
var Props = __importStar(require("../hoc/type"));
var ui_1 = require("../ui");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        button: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            margin: theme.spacing(2, 0),
            '&:hover': {
                backgroundColor: theme.palette.error.dark
            }
        },
        icon: {
            marginRight: theme.spacing(1)
        }
    });
});
var UI = function (props) {
    var classes = useStyles();
    var _a = props.label, label = _a === void 0 ? 'Delete' : _a, onClick = props.onClick;
    return (react_1["default"].createElement(Button_1["default"], { variant: "contained", className: classes.button, onClick: onClick },
        react_1["default"].createElement(Delete_1["default"], { className: classes.icon }),
        label));
};
var DeleteArgs = {
    messages: Props.messagesDefault,
    AlertDialog: ui_1.AlertDialog,
    UI: UI,
    useSnackbar: notistack_1.useSnackbar,
    confirmMessage: utils_1.confirmMessage,
    label: 'Delete'
};
exports.Delete = Hoc.Data.Delete.Main(DeleteArgs);
exports.DeleteWRedirect = function (props) {
    return Hoc.Data.Delete.DeleteWRedirect(exports.Delete)(props);
};
